module.exports = __webpack_public_path__ + "img/calendar_goals.2054c2f4.svg";